import React, { useMemo } from 'react';
import styled from 'styled-components';
import CopyrightIcon from '@material-ui/icons/Copyright';

import { ReactComponent as TelegramIcon } from 'assets/images/telegram.svg';
import { ReactComponent as TwitterIcon } from 'assets/images/twitter.svg';
import { ReactComponent as MediumIcon } from 'assets/images/medium.svg';

import HunnyPartner from './HunnyPartner';
import HunnyLogo from 'assets/images/hunny-logo-text.png';
import { Trans, useTranslation } from 'react-i18next';
import { LANGUAGES } from 'config/constants/language';
import { Link } from 'react-router-dom';
import { MODULES } from 'config/constants/modules';

const Footer: React.FC = () => {
	const { i18n } = useTranslation();

	return (
		<>
			<StyledFooter style={{ flexDirection: 'column' }} className="footer_contact">
				<StyledDisclaimerContainer>
					<StyleWrapLogoAndDescription>
						<img
							src={HunnyLogo}
							style={{
								width: 180,
							}}
						/>
						<StyledDisclaimerContent>
							<Trans>
								Hunny NFT Marketplace | A blockchain based peer-to-peer marketplace that connects
								artists and collectors. Collect, buy and sell your exclusive rare digital NFT
								artwork.
							</Trans>
						</StyledDisclaimerContent>
					</StyleWrapLogoAndDescription>
					<StyledAbout>
						<StyleWrapLink>
							<p className="title">
								<Trans>About</Trans>
							</p>
							<a href="https://docs.pancakehunny.finance" target="_blank">
								<Trans>Hunny Marketplace</Trans>
							</a>
							<a
								href="https://docs.pancakehunny.finance/products/hunnymarketplace-non-fungible-hunny"
								target="_blank"
							>
								<Trans>Documents</Trans>
							</a>
						</StyleWrapLink>
						<StyleWrapLink>
							<p className="title">
								<Trans>Service</Trans>
							</p>

							<a
								href=" https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x565b72163f17849832a692a3c5928cc502f46d69"
								target="_blank"
							>
								<Trans>Buy HUNNY</Trans>
							</a>
							<Link to={MODULES.MARKETPLACE}>
								<Trans>Marketplace</Trans>
							</Link>
							<Link to={MODULES.MYSTERY_BOXES}>
								<Trans>Mystery Boxes</Trans>
							</Link>
						</StyleWrapLink>
						<StyleWrapLink>
							<p className="title">
								<Trans>Help</Trans>
							</p>
							{/* <a
                href="https://docs.pancakehunny.finance/products/hunnyplay/hunnyplay-terms-and-conditions"
                target="_blank"
              >
                <Trans>Term of Service</Trans>
              </a> 
            /// TODO Hide for this version
              */}
							<a href="https://blog.pancakehunny.finance/" target="_blank">
								<Trans>Blog</Trans>
							</a>
							<a href="https://t.me/PancakeHunny" target="_blank">
								<Trans>Telegram</Trans>
							</a>
							<a href="https://twitter.com/HunnyFinance" target="_blank">
								<Trans>Twitter</Trans>
							</a>
							<a href="https://www.reddit.com/r/HunnyFinance/" target="_blank">
								<Trans>Reddit</Trans>
							</a>
							<a href="https://medium.com/HunnyFinance" target="_blank">
								<Trans>Medium</Trans>
							</a>
						</StyleWrapLink>
					</StyledAbout>
				</StyledDisclaimerContainer>

				<StyledPartnerContainer>
					<HunnyPartner />
				</StyledPartnerContainer>
			</StyledFooter>

			<StyledResponsiveFooter>
				<StyledResponsiveAbout>
					<StyleWrapLink>
						<p className="title">
							<Trans>About</Trans>
						</p>
						<a href="https://docs.pancakehunny.finance" target="_blank">
							<Trans>Hunny Marketplace</Trans>
						</a>
						<a
							href="https://docs.pancakehunny.finance/products/hunnymarketplace-non-fungible-hunny"
							target="_blank"
						>
							<Trans>Documents</Trans>
						</a>
					</StyleWrapLink>
					<StyleWrapLink>
						<p className="title">
							<Trans>Service</Trans>
						</p>

						<a
							href=" https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x565b72163f17849832a692a3c5928cc502f46d69"
							target="_blank"
						>
							<Trans>Buy HUNNY</Trans>
						</a>
						<Link to={MODULES.MARKETPLACE}>
							<Trans>Marketplace</Trans>
						</Link>
						<Link to={MODULES.MYSTERY_BOXES}>
							<Trans>Mystery Boxes</Trans>
						</Link>
					</StyleWrapLink>
					<StyleWrapLink>
						<p className="title">
							<Trans>Help</Trans>
						</p>
						{/* <a
              href="https://docs.pancakehunny.finance/products/hunnyplay/hunnyplay-terms-and-conditions"
              target="_blank"
            >
              <Trans>Term of Service</Trans>
            </a> 
            /// TODO Hide for this version
            */}
						<a href="https://blog.pancakehunny.finance/" target="_blank">
							<Trans>Blog</Trans>
						</a>
						<a href="https://t.me/PancakeHunny" target="_blank">
							<Trans>Telegram</Trans>
						</a>
						<a href="https://twitter.com/HunnyFinance" target="_blank">
							<Trans>Twitter</Trans>
						</a>
						<a href="https://www.reddit.com/r/HunnyFinance/" target="_blank">
							<Trans>Reddit</Trans>
						</a>
						<a href="https://medium.com/HunnyFinance" target="_blank">
							<Trans>Medium</Trans>
						</a>
					</StyleWrapLink>
				</StyledResponsiveAbout>
			</StyledResponsiveFooter>

			<StyledFooter>
				<StyledContainer>
					<StyledLicense>
						<CopyrightIcon style={{ fontSize: 16, marginRight: 4 }} />
						<StyledLicenseContent>
							<Trans>2021 Hunny NFT Marketplace All Rights Reserved</Trans>
						</StyledLicenseContent>
					</StyledLicense>

					<StyledCommunity>
						<a href="https://twitter.com/PancakeHunny" target="_blank">
							<TwitterIcon />
						</a>
						<a href="https://t.me/PancakeHunny" target="_blank">
							<TelegramIcon />
						</a>
						<a href="https://pancakehunny.medium.com/" target="_blank">
							<MediumIcon />
						</a>
					</StyledCommunity>
				</StyledContainer>
			</StyledFooter>
		</>
	);
};

const StyledFooter = styled.div`
	background: ${(props) => props.theme.color.dark[500]};
	display: flex;
	border-top: 1px solid ${(props) => props.theme.primary.border};
	justify-content: space-between;
	width: 100%;
	box-sizing: border-box;

	@media (max-width: 1200px) {
		padding-bottom: 50px;

		&.footer_contact {
			padding-bottom: 0px;
		}
	}

	@media (max-width: 768px) {
		padding-bottom: 50px;
	}

	@media (max-width: 580px) {
		padding-bottom: 24px;
	}
`;

const StyledLicenseContent = styled.div``;

const StyledResponsiveFooter = styled(StyledFooter)`
	justify-content: center;
	border: none;
`;

const StyledDisclaimerContent = styled.div`
	margin-top: 24px;
	padding-bottom: 12px;
	color: #c7c9d9;

	line-height: 20px;
	display: flex;
	align-items: center;

	@media (max-width: 425px) {
		text-align: center;
	}
`;

const StyledResponsiveAbout = styled.div`
	display: none;
	justify-content: space-evenly;
	width: 100%;

	@media (max-width: 768px) {
		display: flex;
	}
`;

const StyledLicense = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${(props) => props.theme.color.grey[600]};
	font-size: 14px;

	@media (max-width: 769px) {
		margin: 16px 0 8px 0;
	}

	svg {
		color: ${(props) => props.theme.color.grey[600]};
	}
`;

const StyledContainer = styled.div`
	display: flex;
	max-width: ${(props) => props.theme.siteWidth};
	width: 100%;
	padding: 8px;
	margin: auto;
	padding: 28px;
	box-sizing: border-box;
	justify-content: space-between;

	@media (max-width: 768px) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0px 12px;
		width: 100% !important;
		margin: 24px 5px;
	}
`;

const StyleWrapLogoAndDescription = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	max-width: 50%;
	min-width: 50%;

	@media (max-width: 768px) {
		max-width: 90%;
		min-width: 90%;
	}

	@media (max-width: 599px) {
		align-items: center;
	}
`;

const StyledDisclaimerContainer = styled(StyledContainer)`
	display: flex;
	margin-top: 32px;
	height: auto;
	justify-content: space-between;

	@media (max-width: 599px) {
		flex-wrap: wrap;
		margin-top: 32px;
	}
`;

const StyledAbout = styled.div`
	display: flex;
	flex: 1;
	max-width: 50%;
	min-width: 50%;
	justify-content: space-between;

	@media (max-width: 768px) {
		display: none;
	}
`;

const StyleWrapLink = styled.div`
	margin-left: 32px;
	display: flex;
	flex-direction: column;
	color: #c7c9d9;
	justify-content: flex-start;

	.title {
		font-weight: bold;
		margin-top: 0px;
	}

	a {
		color: #c7c9d9;
		width: max-content;
		word-break: keep-all;
		font-size: 14px;
		margin: 8px 0;
		text-decoration: none;
	}

	@media (max-width: 599px) {
		margin-left: 0px;
		width: 100%;

		.title,
		a {
			width: 100%;
			text-align: center;
		}
	}
`;

const StyledPartnerContainer = styled(StyledContainer)`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: auto;
	padding: 46px 24px;
`;

const StyledCommunity = styled.div`
	display: flex;
	align-items: center;

	svg {
		margin-left: 10px;
	}

	@media (max-width: 425px) {
		margin: 8px 0 18px 0;
	}
`;

export default Footer;
